<template>
  <Tab no-close @close="removeCurrent">
    <template #toolbar-help>
      <v-btn class="tw-mr-2" fab text x-small :title="$t('dashboard.help.show')" @click="showHelp(menu,page)">
            <span class="mr-1">
              <v-icon color="primary" x-small>fa fa-question</v-icon>
            </span>
      </v-btn>
    </template>
    <template #container>
      <!-- ------------------------ Main menu ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="menu/company/page" name="company">
        <template #menu>
          <div class="float-right" style="position:relative; top:-5px;">
            <v-btn v-if="isRowView" :title="$t('menu.organized.grid')" color="primary" icon @click="mainMenuByGrid">
              <v-icon small>fas fa-th</v-icon>
            </v-btn>
            <v-btn v-if="isGridView" :title="$t('menu.organized.row')" color="primary" icon @click="mainMenuByRow">
              <v-icon small>fas fa-th-list</v-icon>
            </v-btn>
          </div>
        </template>
        <template #content>
          <v-container>
            <v-row>
              <!-- Menus -->
              <v-col cols="6">
                <v-row id="main-menu-account">
                  <!-- ACCOUNT -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="6" md="3">
                    <v-card @click="account"
                        :title="$t('dashboard.account.menu_tooltip')"
                        class="sr-menu-btn elevation-8"
                        hover
                    >
                      <v-icon class="mt-4" color="primary">fa-user</v-icon>
                      <v-card-text>{{ $t("dashboard.account.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                    <DocumentationDiv icon="false" :title="false" path="menu/company/account" :key="$i18n.locale"/>
                  </v-col>

                  <!-- SITES -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="6" md="3">
                    <v-card
                        :title="$t('dashboard.websites.menu_tooltip')"
                        class="sr-menu-btn elevation-8"
                        hover
                        @click="websites"
                    >
                      <v-icon class="mt-4" color="primary">fa-globe</v-icon>
                      <v-card-text>{{ $t("dashboard.websites.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                    <DocumentationDiv icon="false" :title="false" path="menu/company/websites" :key="$i18n.locale"/>
                  </v-col>

                  <!-- PRODUCTS -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="6" md="3">
                    <v-card
                        :title="$t('dashboard.products.menu_tooltip')"
                        class="sr-menu-btn elevation-8"
                        hover
                        @click="products"
                    >
                      <v-icon class="mt-4" color="primary">fa-tags</v-icon>
                      <v-card-text>{{ $t("dashboard.products.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                    <DocumentationDiv icon="false" :title="false" path="menu/company/products" :key="$i18n.locale"/>
                  </v-col>

                  <!-- Parameters -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="6" md="3">
                    <v-card
                        :title="$t('dashboard.parameters.menu_tooltip')"
                        class="sr-menu-btn elevation-8"
                        hover
                        @click="parameters"
                    >
                      <v-icon class="mt-4" color="primary">fa-cog</v-icon>
                      <v-card-text>{{ $t("dashboard.parameters.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="9">
                    <DocumentationDiv icon="false" :title="false" path="menu/company/parameters" :key="$i18n.locale"/>
                  </v-col>

                  <!-- Notfications -->
                  <div class="tw-hidden">
                    <hr v-if="!isGridView" class="sr-hr-menu" />
                    <v-col cols="6" md="4">
                      <v-card id="notification_menu" class="sr-menu-btn elevation-8" hover @click="notifications">
                        <v-icon class="mt-4" color="primary">fa-bell</v-icon>
                        <v-card-text>{{ $t("dashboard.notifications.title") }}</v-card-text>
                      </v-card>
                    </v-col>
                    <v-col v-if="!isGridView" class="d-flex align-center" cols="12" md="8">
                      <DocumentationDiv icon="false" path="menu/company/notifications" :key="$i18n.locale"/>
                    </v-col>
                  </div>
                  <!-- documentation -->
                  <div class="tw-hidden">
                    <hr v-if="!isGridView && isSecuratingAccount" class="sr-hr-menu" />
                    <v-col v-if="isSecuratingAccount" cols="6" md="4">
                      <v-card id="documentation_menu" class="sr-menu-btn elevation-8" hover @click="documentation">
                        <v-icon class="mt-4" color="primary">fa-question-circle</v-icon>
                        <v-card-text>{{ $t("dashboard.documentation.title") }}</v-card-text>
                      </v-card>
                    </v-col>
                    <v-col v-if="!isGridView && isSecuratingAccount" class="d-flex align-center" cols="12" md="8">
                      <DocumentationDiv icon="false" path="menu/company/documentation" :key="$i18n.locale"/>
                    </v-col>
                  </div>
                </v-row>
                <v-row id="main-menu-moderation">
                  <!-- MODERATION -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="12" md="3">
                    <v-card
                      :title="$t('dashboard.reviews.menu_tooltip')"
                      :class="[
                        'sr-menu-btn elevation-8',
                        {
                          'sr-menu-btn-disabled': !permissions.reviewsModeration,
                        },
                      ]"
                      hover
                      @click="reviewsModeration"
                    >
                      <v-icon class="mt-4" color="primary">fa-splotch</v-icon>
                      <v-card-text>{{ $t("dashboard.reviewsModeration.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex align-center" cols="12" md="9">
                    <div v-if="!permissions.reviewsModeration" class="mb-2" v-html="$t('menu.noPermission')"></div>
                    <DocumentationDiv :title="false" icon="false" path="menu/company/reviews" :key="$i18n.locale"/>
                  </v-col>
                </v-row>
                <!-- STORIES Removed 29/10/22 -->
                <v-row v-if="false" id="main-menu-stories">
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="12" md="3">
                    <v-card
                      :title="$t('dashboard.stories.menu_tooltip')"
                      :class="['sr-menu-btn elevation-8']"
                      hover
                      @click="stories"
                    >
                      <v-icon class="mt-4" color="primary">fa-book</v-icon>
                      <v-card-text>{{ $t("dashboard.stories.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex align-center" cols="12" md="9">
                    <div v-if="!permissions.reviewsModeration" class="mb-2" v-html="$t('menu.noPermission')"></div>
                    <DocumentationDiv :title="false" icon="false" path="menu/company/stories" :key="$i18n.locale"/>
                  </v-col>

                </v-row>
                <v-row id="main-menu-invitation">
                  <!-- INVITATIONS -->
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="12" md="3">
                    <v-card
                        :title="$t('dashboard.invitation.menu_tooltip')"
                        :class="[
                        'sr-menu-btn elevation-8',
                        {
                          'sr-menu-btn-disabled': !permissions.invitations,
                        },
                      ]"
                        hover
                        @click="invitations"
                    >
                      <v-icon class="mt-4" color="primary">fa-chart-line</v-icon>
                      <v-card-text>{{ $t("dashboard.invitation.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex align-center" cols="12" md="9">
                    <div v-if="!permissions.invitations" class="mb-2" v-html="$t('menu.noPermission')"></div>
                    <DocumentationDiv icon="false" :title="false" path="menu/company/invitations" :key="$i18n.locale"/>
                  </v-col>
                </v-row>
                <!-- SUGGESTION Removed 29/10/22 -->
                <v-row v-if="false" id="main-menu-suggestion">
                  <hr v-if="!isGridView" class="sr-hr-menu" />
                  <v-col cols="12" md="3">
                    <v-card @click="suggestions"
                        :title="$t('dashboard.suggestions.menu_tooltip')"
                        :class="['sr-menu-btn elevation-8']"
                        hover
                    >
                      <v-icon class="mt-4" color="primary">fa-fire-alt</v-icon>
                      <v-card-text>{{ $t("dashboard.suggestions.title") }}</v-card-text>
                    </v-card>
                  </v-col>
                  <v-col class="d-flex align-center" cols="12" md="9">
                    <div v-if="!permissions.reviewsModeration" class="mb-2" v-html="$t('menu.noPermission')"></div>
                    <DocumentationDiv :title="false" icon="false" path="menu/company/suggestions" :key="$i18n.locale"/>
                  </v-col>
                </v-row>
              </v-col>
              <!-- Statistiques -->
              <v-col cols="6">
                <StatisticsChart></StatisticsChart>
              </v-col>
            </v-row>
          </v-container>
        </template>
      </TabPage>
      <!-- ------------------------ notifications ------------------------ -->
      <TabPage :menu="menu" :page="page" documentation-path="menu/company/notifications/page" name="notifications">
        <template #content></template>
      </TabPage>
    </template>
  </Tab>
</template>

<script>
import tab from "../../../../mixins/tab"
import StatisticsChart from "../../charts/StatisticsChart"
import { Types as TypesSnackbar } from "../../../../store/modules/snackbar"

export default {
  name: "Menu",
  mixins: [tab],
  components: {
    StatisticsChart,
  },
  data: () => ({
    plan: null,
    billing: null,
    ordered: null,
    menu: "menu",
    pages: ["company"],
    page: "company",

    storiesTitle: null,

    form: {
      suggestion: "",
    },
    permissions: {
      reviewsModeration: false,
      emailing: false,
      invitations: false,
    },
  }),
  mounted() {
    this.reloadPreviousOpenedTab()

    this.hasPermission("CLIENT_REVIEWS_MODERATION", "reviewsModeration")
    this.hasPermission("CLIENT_REVIEWS_SOLICITATION", "invitations")

    this.bindQuery("plan")
    this.bindQuery("billing")
    this.bindQuery("ordered")

    if ((this.plan !== null && this.billing !== null) || this.ordered !== null) {
      this.account()
    }

    if (window.location.href.match(/notifications$/)) {
      this.page = "notifications"
    }
  },
  computed: {
    isSecuratingAccount() {
      return this.$store.state.auth.user["doc"] === true
    },
    isGridView() {
      return this.$store.state.application.currentMenuStyle === this.$store.state.application.menuStyles.GRID
    },
    isRowView() {
      return this.$store.state.application.currentMenuStyle === this.$store.state.application.menuStyles.ROW
    },
  },
  methods: {
    mainMenuByRow() {
      this.$store.state.application.currentMenuStyle = this.$store.state.application.menuStyles.ROW
    },
    mainMenuByGrid() {
      this.$store.state.application.currentMenuStyle = this.$store.state.application.menuStyles.GRID
    },
    bindQuery(name) {
      this[name] = this.$route.query.hasOwnProperty(name) ? Number(this.$route.query[name]) : null
    },
    hasPermission(permission, name) {
      this.$axios
        .post("/office/common/permissions", { permission })
        .then(() => (this.permissions[name] = true))
        .catch(() => {
          // Remove tab if opened
          const tabName = name.charAt(0).toUpperCase() + name.slice(1)
          this.permissions[name] = false
          const tab = this.tabs.find(tab => tab.component === tabName)

          if (tab && tab.hasOwnProperty("uuid")) {
            this.remove(tab.uuid)
          }
        })
    },
    submitSuggest() {
      this.$axios
        .post("/office/common/crawler/add", this.form)
        .then(() => {
          this.suggestDialogue = false
        })
        .catch(() => {
          this.suggestDialogue = false
        })
    },
    invitations() {
      if (!this.permissions.invitations) {
        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("menu.noPermission"),
          config: { timeout: 3 * 1000, color: "error" },
        })
      } else {
        this.push({
          singleton: true,
          name: "dashboard.invitation.title",
          component: "Invitations",
        })
      }
    },
    account() {
      this.push({
        singleton: true,
        name: "dashboard.account.title",
        component: "Account",
      })
    },
    social() {
      this.push({
        singleton: true,
        name: "dashboard.social.title",
        component: "Social",
      })
    },
    reviews() {
      this.push({
        singleton: true,
        name: "dashboard.reviews.title",
        component: "Reviews",
      })
    },
    suggestions() {
      this.push({
        singleton: true,
        name: "dashboard.suggestions.title",
        component: "suggestionsParams",
      })
    },
    parameters() {
      this.push({
        singleton: true,
        name: "dashboard.parameters.title",
        component: "Parameters",
      })
    },
    stories() {
      if (!this.permissions.reviewsModeration) {
        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("menu.noPermission"),
          config: { timeout: 3 * 1000, color: "error" },
        })
      } else {
        this.push({
          singleton: true,
          name: "dashboard.stories.title",
          component: "Stories",
        })
      }
    },
    reviewsModeration() {
      if (!this.permissions.reviewsModeration) {
        this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
          lines: this.$t("menu.noPermission"),
          config: { timeout: 3 * 1000, color: "error" },
        })
      } else {
        this.push({
          singleton: true,
          name: "dashboard.reviewsModeration.title",
          component: "Reviews",
        })
      }
    },
    feed() {
      this.push({
        singleton: true,
        name: "dashboard.feed.title",
        component: "Feed",
      })
    },
    ranking() {
      this.push({
        singleton: true,
        name: "dashboard.ranking.title",
        component: "Ranking",
      })
    },
    websites() {
      this.push({
        singleton: true,
        name: "dashboard.websites.title",
        component: "Websites",
      })
    },
    products() {
      this.push({
        singleton: true,
        name: "dashboard.products.title",
        component: "Products",
      })
    },
    userGroups() {
      this.push({
        singleton: true,
        name: "dashboard.userGroups.title",
        component: "Groups",
      })
    },
    groups() {
      this.push({
        singleton: true,
        name: "dashboard.groups.title",
        component: "Groups",
      })
    },
    documentation() {
      this.push({
        singleton: true,
        name: "dashboard.documentation.title",
        component: "Documentation",
      })
    },
    notifications() {
      this.push({
        singleton: true,
        name: "dashboard.notifications.title",
        component: "Notifications",
      })
    },
  },
}
</script>
